<template>
  <div>
    <div class="card card-kriteria">
      <!-- <span class="text-grey">Kriteria Penilaian</span> -->
      <b-container>
        <b-row class="mt-1">
          <b-col>
            <h3><b-badge class="mr-1" pill style="background-color: #3751E4; color:white">A</b-badge></h3>
            <span style="color: #3751E4">80.00 - 100.00</span>
          </b-col>
          <b-col>
            <h3><b-badge class="mr-1" pill style="background-color: #17A1FA; color:white">B</b-badge></h3>
            <span style="color: #17A1FA">60.01 - 80.00</span>
          </b-col>
          <b-col>
            <h3><b-badge class="mr-1" pill style="background-color: #FFB800; color:white">C</b-badge></h3>
            <span style="color: #FFB800">40.01 - 60.00</span>
          </b-col>
          <b-col>
            <h3><b-badge class="mr-1" pill style="background-color: #EB8002; color:white">D</b-badge></h3>
            <span style="color: #EB8002">20.01 - 40.00</span>
          </b-col>
          <b-col>
            <h3><b-badge class="mr-1" pill style="background-color: #EF4848; color:white">E</b-badge></h3>
            <span style="color: #EF4848">00.01 - 20.00</span>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KriteriaPenilaian'
 }
</script>
